import React from 'react';
import Constants from "../../../services/Constants";
import {connect} from "react-redux";
import {injectIntl} from "react-intl";
import Signature from "../reception/Signature";
import Document from "../attachments/Document";

class MobilitySignatures extends React.Component {

  componentDidMount() {
    const {journeyId} = this.props;
    if (journeyId) {
      this.props.dispatchFetchJourneySignature({id: journeyId, signatureType: Constants.SIGNATURE_LEGAL_DOCUMENTS.value});
      this.props.dispatchFetchJourneySignature({id: journeyId, signatureType: Constants.SIGNATURE_RENTAL_CONTRACT.value});
      this.props.dispatchFetchJourneySignature({id: journeyId, signatureType: Constants.SIGNATURE_DAMAGE_REPORT.value});
    }
  }

  render() {
    const {intl:{formatMessage}, intervention} = this.props;

    const legalDocumentSignature = intervention[Constants.SIGNATURE_LEGAL_DOCUMENTS.value];
    const rentalContractSignature = intervention[Constants.SIGNATURE_RENTAL_CONTRACT.value];
    const damageReportSignature = intervention[Constants.SIGNATURE_DAMAGE_REPORT.value];
    const {rentalContract} = intervention.journey.properties.mobility;

    return (
      <React.Fragment>
        <div className="row">
          {legalDocumentSignature &&
            <div className="col-md-6 col-xxl-6">
              <h5 className="choice-card__subtitle">{formatMessage(Constants.SIGNATURE_LEGAL_DOCUMENTS.label)}</h5>
              <Signature signature={legalDocumentSignature}/>
              <br/>
            </div>
          }

          {damageReportSignature &&
            <div className="col-md-6 col-xxl-6">
              <h5 className="choice-card__subtitle">{formatMessage(Constants.SIGNATURE_DAMAGE_REPORT.label)}</h5>
              <Signature signature={damageReportSignature}/>
            </div>

          }
        </div>

        {(rentalContractSignature || rentalContract) &&
          <div className="row">
            <div className="col-md-12 col-xxl-12">
              <h5 className="choice-card__subtitle">{formatMessage(Constants.SIGNATURE_RENTAL_CONTRACT.label)}</h5>
              {rentalContractSignature && <Signature signature={rentalContractSignature}/>}
              {rentalContract && <Document document={{...rentalContract, name: rentalContract.filename}} />}
              <br/>
            </div>
          </div>
        }
      </React.Fragment>
    )
  }
}

const mapStateToProps = state => ({
  intervention: state.fetchIntervention.intervention || {},
});

const mapDispatchToProps = dispatch => ({
  dispatchFetchJourneySignature: (params) => dispatch({type: 'FETCH.JOURNEY_SIGNATURE.REQUEST', ...params}),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(MobilitySignatures))



// WEBPACK FOOTER //
// ./src/components/interventiondetail/mobility/MobilitySignatures.js